import {
  NotificationsProvider,
  createNotificationsApi,
  createNotificationThunks,
} from '@lyskraft/notifications';
import type { ThunkDispatch, UnknownAction, Dispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { rtkBaseQuery } from '../rtk';

interface ILkNotificationsProviderProps {
  children: React.ReactNode;
}

export const LkNotificationsProvider = ({ children }: ILkNotificationsProviderProps) => {
  return <NotificationsProvider baseQuery={rtkBaseQuery}>{children}</NotificationsProvider>;
};

const notificationsApi = createNotificationsApi({ baseQuery: rtkBaseQuery });

export const {
  useSearchNotificationsInfiniteQuery,
  useUnreadCountQuery,
  useMarkReadByIdMutation,
  useMarkAllReadMutation,
} = notificationsApi;

export const { requestNotificationPermission, resetSearchNotificationInfiniteQueryState } =
  createNotificationThunks(notificationsApi);

type AppDispatch = ThunkDispatch<any, undefined, UnknownAction> & Dispatch<any>;

export const useNotificationsDispatch: () => AppDispatch = useDispatch;
